var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('WrapperStyled', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "message"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(" " + _vm._s(_vm.title) + " "), _vm.needNewIcon ? _c('div', [_vm._v(_vm._s(_vm.$t('messages.new')))]) : _vm._e()]), _c('div', {
    staticClass: "middle-msg"
  }, [_vm._v(" " + _vm._s(_vm.message) + " ")]), _c('div', {
    staticClass: "actions"
  }, [_c('a', {
    staticClass: "mail button",
    attrs: {
      "href": "mailto:support@talpa-solutions.com"
    }
  }, [_vm._v(_vm._s(_vm.button1Text))]), _c('div', {
    staticClass: "button",
    on: {
      "click": function click($event) {
        return _vm.$emit('accepted');
      }
    }
  }, [_vm._v(_vm._s(_vm.button2Text))])])]), _vm.imageSrc ? _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": _vm.imageSrc
    }
  })]) : _vm._e()])]);
}
var staticRenderFns = []

export { render, staticRenderFns }